<template>
  <div id="app">
    <div id="nav">
      <!-- <router-view v-wechat-title="$route.name" /> -->
      <router-view />
      <loading v-show="loadingStatus"></loading>
    </div>
  </div>
</template>
<script>
import loading from "./components/loading";
import { mapState } from "vuex";
// import { Toast } from "vant";
import common from "../src/common/commonMethods";
export default {
  data() {
    return {};
  },
  components: {
    loading,
  },
  computed: {
    ...mapState(["loadingStatus", "getHeadInfo","baseInfoFromNative"]),
  },
  watch: {
    'getHeadInfo.company': {
      handler(newVal) {
        // common.getDictionary();
        // common.getProvinceList();
        // common.getCountryList();
        
        if(newVal){
          common.getProfessionList();
        }
      },
      deep: true,
      immediate: true,
    },
    
  },
  created() {
    window.addEventListener("beforeunload", () => {
      localStorage.clear();
    });
  },
  methods: {
    
  },
  mounted() {
    if(dsBridge){
        const isMethodRegistered = dsBridge.hasNativeMethod('getBaseInfo');
        if (isMethodRegistered) {
          let _this = this;
          dsBridge.call("getBaseInfo", {}, function (responseData) {
            if (!_this.IOS.ios()) {
              _this.$store.dispatch("setBaseInfoFromNatvie", JSON.parse(responseData));
            }else {
              _this.$store.dispatch("setBaseInfoFromNatvie", responseData);
            }
          }, function(error) {
            console.log('methodName 不可用');
          })
        }
    }
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium, PingFang SC;
}
.detail-bg {
  background: url(./assets/images/header/floorBg.png) !important;
  background-repeat: repeat-y !important;
  background-size: 100% 1.06rem !important;
  background-color: #ca2415 !important;
}
.van-image-preview__cover {
  width: 100%;
}
.van-swipe__track {
  height: calc(100vh - 2rem);
  margin-top: 1.2rem;
}
.van-image-preview__image {
  height: 100%;
  object-fit: cover;
}
.van-image-preview__cover {
  width: 100%;
}
.imgWrapper {
  width: 100%;
  max-height: 70%;
  /deep/.van-image-preview__image {
    height: 100%;
    object-fit: cover;
  }
  /deep/.van-image-preview__cover {
    width: 100%;
  }
}
.operaImgBtn {
  display: flex;
  justify-content: space-between;
  padding: 0 0.16rem;
  margin: 0.5rem 0 0.42rem;
  color: #fff;
  .returnIcon,
  .picNum,
  .deleteIcon {
    font-size: 0;
    font-size: 0.2rem;
  }
  .picNum {
    font-size: 0.18rem;
    color: #fff;
  }
}
.move-enter-active,
.move-leave-active {
  transition: all 0.3s linear;
  transform: translate3d(0, 0, 0);
}
.move-enter,
.move-leave {
  transform: translate3d(100%, 0, 0);
}

.homes {
  margin-top: 0.46rem;
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  -webkit-touch-callout: none;
}
#nav {
  width: 100%;
  height: 100%;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.customToast{
  padding:0.12rem 0.16rem;
  background-color: rgba(0,0,0,.65);
  border-radius: 0.08rem;
  color:#fff;
  font-size: 0.15rem;
  line-height: 0.21rem;
}
.customBgOpacity{
  background-color: rgba(0,0,0,.55) !important;
}
</style>
